import styled, { css } from 'styled-components';
import { PanelPos } from './SidePanelContainer';

export const SidePanelContainerStyled = styled.div<{ pos: PanelPos }>`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  ${({ pos }) => pos === 'left' ? css`flex-flow: row;` : css`flex-flow: row-reverse;` }
  
  > .AnimatedHamburgerButton {
    position: absolute;
    top: 3px;
    ${({ pos }) => pos === 'left' ? css`left: 3px;` : css`right: 3px;` }
  }
`;

export const PanelStyled = styled.div<{ pos: PanelPos }>`
  height: 100%;
  overflow: hidden;
  position: relative;

  > div {
    ${({ pos }) => pos === 'left' ? css`
      float: right;
      right: 0px;
    ` : css`
      float: left;
      left: 0px;
    `}
    height: 100%;
  }
`;

export const MainAreaStyled = styled.div`
  flex: 1;
  height: 100%;
  position: relative; 
`;

export const TitleBarStyled = styled.div<{ pos: PanelPos }>`
  position: absolute;
  top: 3px;
  height: 46px;
  ${({ pos }) => pos === 'left' ? css`right: 0px;` : css`left: 0px;` }
  pointer-events: none;
`;
